export var HOMEWORK_SUBMISSION_REPOSITORY = 'HOMEWORK_SUBMISSION_REPOSITORY';